import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT,
  COMPONENT_WISE_AG_GRID_PAGINATION,
  COMPONENT_WISE_AG_GRID_PAGINATION_SIZE,
  HMS_PAYMENT_REUQEST_STATUS,
  HMS_PAYMENT_REUQEST_TYPE,
  HMS_REPORT_TEMPLATE_TYPE,
  ERP_INVOICE_RECEIPT_REFUND_PREFIX
} from "../../../core/constants/erpConstants";
import { useHistory } from "react-router-dom";
import {
  deleteErpService,
  deletePaymentRequest,
  getPaymentRequests,
  updatePaymentRequest,
  getReceiptPDFObject,
} from "../ERPActions/erpActions";
import { useSelector } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import AddPaymentRequest from "./AddHMSPaymentRequest";
import AddHMSPaymentRequest from "./AddHMSPaymentRequest";
import { Button } from "@mui/material";
import { helperServices } from "../../../shared/helper";
import HeaderFooterComponent from "../../printConvertion/HeaderAndFooter";
import { generateBillHtml } from "../../printConvertion/DocumentConvert";
import { useOrganization } from "../../../configurations/OrganizationContext";
export default function HMSPaymentRequest(props) {
  console.log("props payment",props);
  console.log("props payment",props.data);
  const [rowData, setRowData] = useState();
  const [filteredRowData, setFilteredRowData] = useState();
  const [showAddPaymentRequestForm, setShowAddPaymentRequestForm] =
    useState(false);
  const org = useOrganization();
  const [patientId, setPatientId] = useState(props.patientId);
  const [visitId, setVisitId] = useState(props.visitId);
  //   const [searchText, setSearchText] = useState(props.searchQuery);
  const [printdata, setPrintData] = useState("");
  const [triggerAction, setTriggerAction] = useState("");
  const [isDisable, setIsDisable] = useState(false);

  const extractFilters = (tagList) => {
    const textTag = tagList?.find((t) => t?.type === "text");
    const dateTag = tagList?.find((t) => t?.type === "date");

    return {
      searchText: textTag ? textTag.value : "",
      dateFrom: dateTag ? dateTag.from : "",
      dateTo: dateTag ? dateTag.to : "",
    };
  };

  const [searchText, setSearchText] = useState(
    extractFilters(props?.searchtags)?.searchText || ""
  );
  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic
  );
  // const history = useHistory();
  //     const handleNavigateToBilling = (row) => {
  //     console.log("test row data",row)
  //       history.push({
  //       pathname: `/billing/${row.patientId}/${row.visitId}`,
  //       state: {
  //         searchState: {
            
  //         }
  //       }
  //   });
  // };
  const paymentRequestColumnDefs = [
    {
      headerName: "Sl No.",
      field: "slNo",
      colId: "slNo",
      flex: 0.25,
      valueGetter: (params) => params.node.rowIndex + 1, // auto row index
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "SL No",
    },
    
    {
      headerName: "Main",
      field: "patientId",
      colId: "patientId",
      // editable: (params) => gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      // editable: true,
      flex: .40,
      // cellClassRules: {
      //     "editable-cell": (params) => params.colDef.editable,
      // },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Main",
    },
    
    {
      headerName: "IP/OP No",
      field: "ipopnumber",
      flex: 0.40,

      valueGetter: (params) => {
        return params.data?.ipopnumber;
      },

      cellRenderer: (params) => {
        if (!params.value) return "";

        const isClickable = typeof params?.context?.onRowClick === "function";

        return isClickable
          ? `<span class="visit-link">${params.value}</span>`
          : `<span class="visit-link-disabled">${params.value}</span>`;
      },

        onCellClicked: (params) => {
          const onRowClick = params?.context?.onRowClick;

          // If no click handler → disable completely
          if (typeof onRowClick !== "function") return;

          if (params.event.target.classList.contains("visit-link")) {
            onRowClick({
              patientId: params.data.patientId,
              visitId: params.data.visitId
            });
          }
        }
      },
    {
      headerName: "Patient Name",
      field: "fullName",
      colId: "patientName",
      // editable: (params) => gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      // editable: true,
      flex: 1,
      // cellClassRules: {
      //     "editable-cell": (params) => params.colDef.editable,
      // },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Patient Name",
    },
    {
      headerName: "Type",
      field: "type",
      colId: "type",
      // editable: (params) => gridDataType === ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      // editable: true,
      // flex: 1,
      // cellClassRules: {
      //     "editable-cell": (params) => params.colDef.editable,
      // },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Patient Name",
    },
    {
      headerName: "Requested Amount",
      field: "displayRequestedAmount",
      colId: "displayRequestedAmount",
      cellStyle: { textAlign: "right" },
      valueGetter: (param) => `₹ ${param.data.requestedAmount}`,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      //cellClass: ["ag-cell-center", "table-head"],
      tooltipField: "Requested Amount",
    },
    {
      headerName: "Requested By",
      field: "requestedByName",
      colId: "requestedByName",
      editable: false,
      // flex: 1,
      // cellStyle: { textAlign: "right" },
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      tooltipField: "Requested By",
    },

    {
      headerName: "Action",
      field: "action",
      flex: 0.5,
      editable: false,
      // cellStyle: { textAlign: 'center', alignItems: 'center', alignContent: 'space-around', borderRightColor: '#D0D0D0', borderRightWidth: 'revert-layer' },
      cellRenderer: "ActionRenderer",
      tooltipField: "Action",
      autoHeight: true,
    },
  ];

  // Add defaultColDef configuration
  const defaultColDef = useMemo(() => {
    return {
      // editable: true,
      sortable: true,
      flex: 1,
      filter: true,
      resizable: true,
      floatingFilter: true,
    };
  }, []);

  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);

  const containerStyle = useMemo(
    () => ({
      width: "100%",
      height: COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT.HMSPaymentRequest,
    }),
    []
  );
  const gridStyle = useMemo(
    () => ({ alignItems: "start", height: "100%", width: "100%" }),
    []
  );

  // First, add the ActionRenderer component at the top of your file
  const ActionRenderer = (cellProps) => {
    console.log("hmspaymentrequest-actionrenderer_props: ", cellProps);
    // if(props.data){
    console.log("hmspaymentrequest-actionrenderer_props: ", cellProps.data);
    // }
    const onDelete = async (cellProps) => {
      console.log("props.data.slNo: ", cellProps.data.slNo, cellProps.rowIndex);

      // Check if the row has soId and soLinID for ERP service deletion
      if (cellProps.data.id && cellProps.data.visitId) {
        try {
          console.log(
            "Deleting PaymentRequest with Id:",
            cellProps.data,
            "visitID:",
            cellProps.data.visitId
          );
          const resCb = await handleDeletePaymentRequest(cellProps.data);
          console.log("ERP service deletion response:", resCb);
        } catch (error) {
          console.error("Error deleting ERP service:", error);
          // You might want to show an error message to the user here
          return; // Exit early if deletion fails
        }
      }

      // Get all row data from the grid
      const allRowData = cellProps.api
        .getModel()
        .rowsToDisplay.map((row) => row.data);
      console.log("allrowdata: ", allRowData);

      // Filter out the row to be deleted
      const updatedRows = allRowData
        .filter((row) => row.id !== cellProps.data.id)
        .map((row, index) => ({
          ...row,
          // slNo: index + 1, // Update serial numbers
        }));

      console.log("updatedRows: ", updatedRows);
      console.log("updatedProps: ", cellProps.api);

      setRowData(updatedRows);
      // Update the grid with new data
      cellProps.api.setRowData(updatedRows);
    };

    const handlePaymentRequestApproval = (cellProps) => {
      console.log("cell props value: ", cellProps);
      const data = cellProps.data;
      data["status"] = HMS_PAYMENT_REUQEST_STATUS.PAYMENT_REQUEST_CONFIRMED;
      props.onPaymentRequestApproved(cellProps.data);
    };

    //  const onRowClick = (cellProps) => {
    //   console.log("cell props value: ", cellProps);
    //   props.onRowClick(cellProps.data);
    //  }

    const handlePrintInvoice = async (cellProps, actionType, rowDataType) => {
      console.log("print inv: ", cellProps.data);
      setIsDisable(true);

      const templateReportType = HMS_REPORT_TEMPLATE_TYPE.RECEIPT;
      const dto = buildManualReceiptDTO(cellProps.data);

      const receptData = await getReceiptPDFObject(
              null,
              props.visitId,
              props.patientId,
              dto
      );

      console.log("Sending DTO to generateBillHtml:", receptData);

      const htmlData = await generateBillHtml(receptData, templateReportType, org?.orgCode);

      setPrintData(htmlData);
      setTriggerAction(actionType);
      setIsDisable(false);
    };

    const buildManualReceiptDTO = (data) => {
      return {
        recNo: "",                                    
        reportName: "Advance Payment Request",              
        regNo: data.patientId,
        visitId: data.visitId,
        customerId: data.custId,
        patientName: data.fullName,
        paymentDate: data.cdt,
        paymentMode: "",                                    
        totalAmount: data.requestedAmount,
        receivedAmount: data.requestedAmount,
        paymentAmountInWords: data.amtInWords,                           
        generatedBy: data.requestedByName || "System",
        paymentCounter: "",
        user: "",                                  
      };
    };

    return (
      <>
        <div className="d-flex gap-3">
          {/* <div>
                        <Button size='medium' onClick={() => handlePaymentRequestApproval(cellProps)} ><CheckIcon fontSize='medium' /></Button>
                    </div> */}
     

     <div
              className="icon-btn text-dark"
              title={isDisable ? "Disabled" : "Print Invoice"}
              onClick={
                !isDisable
                  ? () =>
                      handlePrintInvoice(
                        cellProps,
                        "print",
                        cellProps.data.type
                      )
                  : undefined
              }
              style={{
                pointerEvents: isDisable ? "none" : "auto", // disables click
                opacity: isDisable ? 0.5 : 1, // shows a dimmed style
                cursor: isDisable ? "not-allowed" : "pointer",
              }}
            >
              <i className="material-icons">print</i>
            </div>


          <div
            title="Approve"
            style={{ color: "#4CAF50", cursor: "pointer" }}
            onClick={() => handlePaymentRequestApproval(cellProps)}
          >
            <i className="material-icons">check</i>
          </div>

          <div
            title="Delete"
            style={{ color: "#a32424", cursor: "pointer" }}
            onClick={() => onDelete(cellProps)}
          >
            <i className="material-icons mr-1">delete</i>
          </div>
        </div>
      </>
    );
  };

  const handleCloseHMSAddPaymentRequest = (status) => {
    fetchPaymentRequests();
    setShowAddPaymentRequestForm(status);
  };

  const handleUpdatePaymentRequest = async (paymentRequest) => {
    const savePaymentReq = updatePaymentRequest(paymentRequest);
  };

  const handleDeletePaymentRequest = async (paymentRequest) => {
    const deletePaymentReqResp = deletePaymentRequest(
      paymentRequest.id,
      paymentRequest.visitId
    );
    if (deletePaymentReqResp) {
      console.log("deletePaymentReqResp: ", deletePaymentReqResp);
    }
  };

  
  // // Track mount status to avoid state updates on unmounted component
  // const isComponentMountedRef = useRef(true);

  // useEffect(() => {
  //     return () => {
  //         isComponentMountedRef.current = false;
  //     };
  // }, []);

  const fetchPaymentRequests = async () => {
    try {
      const paymentRequestResp = await getPaymentRequests(visitId, [
        HMS_PAYMENT_REUQEST_STATUS.PAYMENT_REQUEST_REQUESTED,
        HMS_PAYMENT_REUQEST_STATUS.PAYMENT_REQUEST_CONFIRMED,
      ]);
      console.log("c ", paymentRequestResp);
      // if (!isComponentMountedRef.current) return;
      if (paymentRequestResp) {
        setRowData(paymentRequestResp.hmsPaymentRequests);
      }
    } catch (error) {
      console.error("Failed to fetch payment requests:", error);
    }
  };

  const handleFilteredData = () => {
    if (rowData) {
      const allRows = [...rowData];
      console.log("search: && rowData: ", searchText, allRows);
      if (searchText) {
        // const filteredRowData = rowData.filter((row)=>{
        //     // return row.invoiceNo.toLowerCase().includes(search.toLowerCase());
        //     return fuzzyFilter(row, search);
        // });
        let filterRows = [];
        for (let row of rowData) {
          if (helperServices.fuzzyFilter(row, searchText)) {
            // row['displayRequestedAmount'] = row.requestedAmount;
            filterRows.push(row);
          }
        }
        console.log("filtered rows : ", filterRows);

        setFilteredRowData(filterRows);
      } else {
        setFilteredRowData(rowData);
      }
    }
  };

  const updatingFilteredRow = useMemo(
    () => handleFilteredData(rowData, searchText),
    [rowData, searchText]
  );

  useEffect(() => {
    console.log(
      "outstanding biills rowdatas: ",
      filteredRowData,
      props.selectedLocationDetails
    );
    console.log("Search Query : ", searchText);
  }, [filteredRowData]);

  useEffect(() => {
    console.log("patientId:visitId :: ", patientId, visitId, props);
    fetchPaymentRequests();
  }, [props?.reload]);

  useEffect(() => {
    handleFilteredData();
  }, [rowData, searchText]);

  useEffect(() => {
    console.log("Search Query : ", searchText, props?.searchtags);
    setSearchText(extractFilters(props?.searchtags).searchText);
  }, [props?.searchtags]);

  return (
    <>
      <div className="">
        {showAddPaymentRequestForm && (
          <div
          //    style={{paddingInline: '16px'}}
          >
            <AddHMSPaymentRequest
              patientId={patientId}
              visitId={visitId}
              closeHMSAddPaymentRequest={handleCloseHMSAddPaymentRequest}
            />
          </div>
        )}
        <div className="ms-1" style={containerStyle}>
          <div className="ag-theme-balham ag-style ag-header-left pt-3 py-2 w-100 h-100">
            <AgGridReact
              autoSizeStrategy={autoSizeStrategy}
              rowData={filteredRowData}
              pagination={COMPONENT_WISE_AG_GRID_PAGINATION.HMSPaymentRequest}
              paginationPageSize={
                COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.HMSPaymentRequest
              }
              columnDefs={paymentRequestColumnDefs}
              suppressRowClickSelection
              frameworkComponents={{ ActionRenderer: ActionRenderer }}
              defaultColDef={defaultColDef}
               context={{
                onRowClick: props.onRowClick   // ⭐ Add this
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <Button
            type="submit"
            variant="contained"
            className="billingBlueButton"
            // style={{backgroundColor: "#1976d2 !important"}}
            // color="primary"
            onClick={() => setShowAddPaymentRequestForm(true)}
          >
            {" "}
            Add Payment Request{" "}
          </Button>

          

        </div>
          {printdata && triggerAction && (
          <HeaderFooterComponent
            title="Invoice"
            data={printdata}
            triggerAction={triggerAction}
            onComplete={() => {
              setPrintData(""); // clear data
              setTriggerAction(""); // clear action
              console.log("Print action completed and state cleared.");
            }}
          />
        )}
      </div>
    </>
  );
}
